/** @format */

import {
  Box,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { COMPONENT_TITLE_SX } from '../homeStyles';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../../../store/store.app';
import { getBookingPace } from '../../../../Services/service.home';
import { buildPayload } from '../../../Library/appfilter.lib';

function BookingPace() {
  const [tables, setTables] = useState([]);

  const {
    appStore: { appFilters },
  } = useAppContext();

  const basePayload = {};

  const payload = {
    ...buildPayload(appFilters),
    ...basePayload,
  };

  const { PARAMETER, CALC_DATERANGE } = appFilters;

  useEffect(() => {
    if (!PARAMETER || !CALC_DATERANGE) return;

    getBookingPace(payload).then(({ data }) => {
      setTables(data.tables);
    });
  }, [PARAMETER, CALC_DATERANGE]);

  return (
    <Box sx={{ my: 1 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <Typography
          variant="h6"
          textAlign="center"
          color="text.disabled"
          sx={{
            ...COMPONENT_TITLE_SX,
            flexGrow: 1,
            minWidth: 0,
            overflowWrap: 'anywhere',
          }}
        >
          Booking Pace - Rooms
        </Typography>

        <Typography
          fontSize={12}
          color="text.secondary"
          sx={{
            display: { xs: 'none', sm: 'block' },
            position: { xs: 'static', sm: 'absolute' },
            right: 0,
            flexShrink: 0,
            pr: { xs: 1, sm: 0 },
          }}
        >
          Revenue in &#39;000
        </Typography>
      </Box>

      {tables.map((table, index) => (
        <Paper
          variant="outlined"
          key={index}
          sx={{
            backgroundColor: '#f2f2eb',
            width: '100%',
            borderRadius: 2,
            mb: 2,
          }}
        >
          <TableComponent table={table} />
        </Paper>
      ))}
    </Box>
  );
}

function TableComponent({ table }) {
  const { rows } = table;
  const headers = Object.keys(rows[0]);

  const formatValue = (key, row) => {
    const hasRevenue = Object.values(row).some((item) => {
      const regex = /Revenue/gi;
      return regex.test(item);
    });

    const hasOccupancy = Object.values(row).some((item) => {
      const regex = /Occ/gi;
      return regex.test(item);
    });

    if (hasRevenue) {
      return (row[key] / 1000).toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    }

    if (hasOccupancy) {
      return row[key].toLocaleString('en-IN', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    }

    return row[key].toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  return (
    <TableContainer
      sx={{
        borderRadius: 2,
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <Table
        size="small"
        aria-label="booking pace table"
        sx={{
          minWidth: { xs: 0, sm: 480 },
          width: '100%',
          tableLayout: 'auto',
        }}
      >
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell
                key={header}
                sx={{
                  borderRight: '1px solid #e0e0e0',
                  backgroundColor: '#f5f5f5',
                  textAlign: index === 0 ? 'left' : 'right',
                  whiteSpace: 'nowrap',
                  px: { xs: 0.75, sm: 2 },
                }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {headers.map((key, columnIndex) => {
                const isNumber = typeof row[key] === 'number';

                let value;

                if (isNumber) {
                  value = formatValue(key, row);
                } else {
                  value = row[key];
                }

                return (
                  <TableCell
                    key={key}
                    sx={{
                      textAlign:
                        typeof row[key] === 'string' ? 'left' : 'right',

                      color: 'text.secondary',
                      borderRight: '1px solid #e0e0e0',

                      backgroundColor:
                        rowIndex % 2 === 0 ? '#fafafa' : 'white',

                      whiteSpace: 'nowrap',

                      overflowX: 'auto',
                      WebkitOverflowScrolling: 'touch',
                      textOverflow: 'clip',

                      px: { xs: 0.75, sm: 2 },
                    }}
                  >
                    {isNumber ? (
                      <span className="data-number">{value}</span>
                    ) : (
                      value
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default BookingPace;
